<template>
  <div class="flex w-full flex-col gap-10 p-5 pt-2">
    <div v-for="(attribute, index) in attributes" :key="attribute.id">
      <div class="relative flex gap-2">
        <p class="text-attribute text-body-small-m">{{ attribute.name }}</p>
        <div class="!max-w-[200px]">
          <Tooltip class="overflow-hidden" :text="attribute.description" />
        </div>
        <Button
          v-if="attribute?.options?.link"
          :variant="ButtonVariant.Ghost"
          :href="attribute?.options?.link"
          target="_blank"
        >
          {{ t("download_template") }}
        </Button>
      </div>
      <WizardCreateTicketTypeInput
        :index="index"
        :shipment-id="shipmentId"
        :attribute="attribute"
        :type="attribute.type"
        @emit-value="(val) => $emit('attributeChange', val, attribute)"
      />
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
  import type { AttributeWithError } from "~/types/ticket";

  const { t } = useI18n();

  defineProps<{
    attributes: AttributeWithError[];
    shipmentId: string;
  }>();
  defineEmits<{
    attributeChange: [val: string | string[] | { name: string; value: string }[], attribute: AttributeWithError];
  }>();
</script>
